import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import styles from './genericPopup.scss';

const GenericPopup = ({
    imageSource,
    title,
    subtitle,
    description,
    buttonText,
    onRequestClose,
    onButtonClick,
    'data-testid': dataTestId,
}) => {
    const handleOnRequestClose = () => {
        onRequestClose();
    };

    const handleOnActionButtonClicked = () => {
        onButtonClick();
    };

    return (
        <Popup
            className="popup-md"
            onCloseClick={handleOnRequestClose}
            config={{
                fullScreen: false,
                noPadding: false,
                gradient: true,
                scrollable: false,
            }}
        >
            <div className={`${styles.container} container`} data-testid={dataTestId}>
                <div>
                    {imageSource && (
                        <div className="mb10">
                            <img className={styles.image} src={imageSource} data-testid={dataTestId ? `${dataTestId}.image` : undefined} />
                        </div>
                    )}
                    <div className={styles.title} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>
                        {title}
                    </div>
                    <div className="mt16 mb16" data-testid={dataTestId ? `${dataTestId}.subtitle` : undefined}>
                        {subtitle}
                    </div>
                    {!!description && (
                        <div className="mt16 mb16" data-testid={dataTestId ? `${dataTestId}.description` : undefined}>
                            {description}
                        </div>
                    )}
                    <button
                        type="button"
                        onClick={handleOnActionButtonClicked}
                        className="btn btn-primary btn-xl text-uppercase"
                        data-testid={dataTestId ? `${dataTestId}.action-btn` : undefined}
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </Popup>
    );
};

GenericPopup.propTypes = {
    imageSource: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
};

GenericPopup.defaultProps = {
    imageSource: null,
    subtitle: null,
};

export default GenericPopup;
